__turbopack_context__.v({
  "container": "fOLsuq_container",
});
